module.exports = __webpack_public_path__ + "img/WechatIMG6042.53e034db.jpg";